(() => {
  const poolSelector = '[data-zenit-recommendations-pool]';

  const shuffle = (items) => {
    for (let index = items.length - 1; index > 0; index -= 1) {
      const swapIndex = Math.floor(Math.random() * (index + 1));
      [items[index], items[swapIndex]] = [items[swapIndex], items[index]];
    }

    return items;
  };

  const preparePool = (pool) => {
    if (!(pool instanceof HTMLElement) || pool.dataset.shuffleReady === 'true') return;

    const candidates = Array.from(pool.querySelectorAll('[data-recommendation-candidate]'));
    if (candidates.length === 0) return;

    const requestedCount = Number.parseInt(pool.dataset.productsToShow, 10);
    const visibleCount = Math.min(Number.isNaN(requestedCount) ? 3 : requestedCount, candidates.length);
    const shuffledCandidates = shuffle(candidates);

    shuffledCandidates.forEach((candidate, index) => {
      candidate.hidden = index >= visibleCount;
      pool.append(candidate);
    });

    pool.dataset.shuffleReady = 'true';
    pool.closest('product-recommendations')?.setAttribute('data-recommendations-ready', '');

    if (window.matchMedia('(max-width: 47.99rem)').matches && pool.dataset.initialPositionReady !== 'true') {
      const visibleCandidates = shuffledCandidates.slice(0, visibleCount);
      const initialCandidate = visibleCandidates[Math.floor(visibleCandidates.length / 2)];
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (initialCandidate) {
            const left = initialCandidate.offsetLeft - (pool.clientWidth - initialCandidate.offsetWidth) / 2;
            pool.scrollTo({ left: Math.max(0, left), behavior: 'auto' });
          }
          pool.dataset.initialPositionReady = 'true';
        });
      });
    }
  };

  const preparePools = (root = document) => {
    if (root instanceof Element && root.matches(poolSelector)) preparePool(root);
    root.querySelectorAll?.(poolSelector).forEach(preparePool);
  };

  preparePools();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) preparePools(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', (event) => preparePools(event.target));
})();
